export const categoryList = [
  {
    slug: "yule",
    name: "娱乐八卦",
    desc: "演出、演唱会、艺能动态与八卦风向，一线吃瓜情报都在这。",
    count: 126,
    icon: "ri-mic-line",
  },
  {
    slug: "yingshi",
    name: "影视综艺",
    desc: "剧集口碑、综艺剪辑争议、大结局讨论，追剧党必看。",
    count: 98,
    icon: "ri-movie-2-line",
  },
  {
    slug: "keji",
    name: "科技数码",
    desc: "新机发布、价格波动、系统更新与产品翻车实录。",
    count: 154,
    icon: "ri-smartphone-line",
  },
  {
    slug: "youxi",
    name: "游戏电竞",
    desc: "赛事判罚、版本更新、独立游戏出圈与玩家热议合集。",
    count: 87,
    icon: "ri-gamepad-line",
  },
  {
    slug: "shehui",
    name: "社会民生",
    desc: "消费维权、城市文旅、公共话题里的真实讨论。",
    count: 112,
    icon: "ri-community-line",
  },
  {
    slug: "caijing",
    name: "财经商业",
    desc: "品牌翻红、联名出圈、价格战与生意场上的新鲜事。",
    count: 73,
    icon: "ri-line-chart-line",
  },
];